<ct-lib-dashboard-card
  [title]="'jobboard.platform.dashboard.applications.title' | transloco"
  [icon]="icons.briefcase"
  [scrollable]="dashboard.applications().length > 0"
>
  @if (dashboard.applications().length > 0) {
    <span dashboardCardHeaderActions class="count text-muted">
      {{ dashboard.applications().length }}
    </span>
  }

  @if (dashboard.applications().length === 0) {
    <ct-lib-empty-placeholder
      [icon]="icons.briefcase"
      [title]="'jobboard.platform.dashboard.applications.empty-title' | transloco"
      [text]="'jobboard.platform.dashboard.applications.empty-text' | transloco"
    >
      <div emptyPlaceholderActions>
        <app-button
          variant="primary"
          [iconStart]="icons.search"
          [routerLink]="discoverJobsLink()"
        >
          {{ 'jobboard.platform.dashboard.applications.empty-cta' | transloco }}
        </app-button>
      </div>
    </ct-lib-empty-placeholder>
  } @else {
    <div class="application-list" role="list">
      @for (application of dashboard.previewApplications(); track application.id) {
        <app-platform-dashboard-application-item
          role="listitem"
          [application]="application"
        ></app-platform-dashboard-application-item>
      }
    </div>
  }

  @if (dashboard.applications().length > 0) {
    <a dashboardCardFooter class="view-all-link" [routerLink]="['/applications']">
      {{ 'jobboard.platform.dashboard.applications.view-all' | transloco }}
      <fa-icon [icon]="icons.chevronRight" aria-hidden="true"></fa-icon>
    </a>
  }
</ct-lib-dashboard-card>
